import React, {PropsWithChildren} from 'react';
import RadioButton from '../../../../incase-domain/components/radioButton/RadioButton';

interface AuthMethodItemProps {
    label: string;
    description: string;
    isSelected: boolean;
    onClick: () => void;
    dataCy?: string;
}

function AuthMethodItem({label, description, isSelected, onClick, dataCy, children}: PropsWithChildren<AuthMethodItemProps>): JSX.Element {
    return (
        <div className={`c-authMethodItem ${isSelected ? 'c-authMethodItem--active' : ''}`} data-cy={dataCy}>
            <RadioButton
                label={label}
                description={description}
                active={isSelected}
                onClick={onClick}
                size="lg"
                enableHover={false}
                dataCy={`${dataCy}-default`}
            />

            <div className="c-authMethodItem__children">{children}</div>
        </div>
    );
}

export default AuthMethodItem;
